import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducer/authReducer';
import categoryReducer from './reducer/categoryReducer';


import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import topicReducer from './reducer/topicReducer';
import modalReducer from './reducer/modalReducer';
import courseContentReducer from './reducer/courseContentReducer';
import userReducer from './reducer/userReducer';
import coursesReducer from './reducer/courseReducer';
import quizReducer from './reducer/quizReducer';
import quizDetailsReducer from './reducer/quizDetailsReducer';
import batchReducer from './reducer/batchReducer';
import batchClassReducer from './reducer/batchClassReducer';
import appContentReducer from './reducer/appContentReducer'
import commonReducer from './reducer/commonReducer';
import goalReducer from './reducer/goalReducer'
import discountReducer from './reducer/discountReducer'
import studentReducer from './reducer/studentReducer';
import dashboardReducer from './reducer/dashboardReducer';
import ordersReducer from './reducer/ordersReducer';
import roleReducer from './reducer/roleReducer';
import testimonialReducer from './reducer/testimonialReducer';
import subjectsReducer from './reducer/subjectsReducer';
import clearCacheReducer from './reducer/clearCacheReducer';
import chatReducer from './reducer/chatReducer';
import companyDetailReducer from './reducer/companyDetailReducer';
import downloadReducer from './reducer/downloadReducer';
import auditUser from './reducer/auditUserReducer'
import auditProcess from './reducer/auditProcess';
import noticeBoard from './reducer/noticeBoardReducer'
import banner from './reducer/banner'
import notification from './reducer/notificationReducer';
import handout from './reducer/handOutReducer'
import documentsReducer from './reducer/documentsReducer'
import rulesReducer from './reducer/rulesReducer'
import eSubjectsReducer from './reducer/e-subjectsReducer'
import questionType from './reducer/questionTypeReducer';
import paperTypeReducer from './reducer/paperTypeReducer';
import batchClassTypeReducer from './reducer/batchClassTypeReducer';
import subjectPaperReducer from './reducer/subjectPaperReducer';
import sectionNameReducer from './reducer/sectionNameReducer';
import difficultyLevelReducer from './reducer/difficultyLevelReducer';
import testPaperReducer from './reducer/testPaperReducer';
import groupPaperReducer from './reducer/groupPaperReducer';
import examPaperReducer from './reducer/examPaperReducer';
import liveResultReducer from './reducer/liveResultReducer';
import eSubjectGoalsReducer from './reducer/e-subjectGoalsReducer';
import avatarReducer from './reducer/avatarReducer';
import examCenterReducer from './reducer/examCenterReducer';
import admitCardReducer from './reducer/admitCardReducer';
import scholarshipReducer from './reducer/scholarshipReducer';
import installmentReducer from './reducer/installmentReducer';
import reportReducer from './reducer/reportReducer';
import samplePaperReducer from './reducer/samplePaperReducer';
import currentClassReducer from './reducer/currentClassReducer';
import campusReducer from './reducer/campusReducer';
import regUserReducer from './reducer/regUserReducer';
import testEngagmentReducer from './reducer/testEngagmentReducer';
import changeCourseReducer from './reducer/changeCourseReducer';
import resultListReducer from './reducer/resultListReducer';
import admissionReportReducer from './reducer/admissionReportReducer';
import noticePDFReducer from './reducer/noticePDFReducer';
import examCalendarReducer from './reducer/examCalendarReducer';
import feedbackReducer from './reducer/feedbackReducer';
import academicYearReducer from './reducer/academicYearReducer';
import userBatchReducer from './reducer/userBatchReducer';
import facultyTaskReducer from './reducer/facultyTaskReducer';
import sparkReducer from './reducer/sparkReducer';
import resultBanner from './reducer/resultBanner';
import testSeriesReducer from './reducer/testSeriesReducer';
import jeeMarksReducer from './reducer/jeeMarksReducer';
import enquiresReducer from './reducer/enquiresReducer';
import messageReducer from './reducer/messageReducer';
import agentEnquiresReducer from './reducer/agentEnquiresReducer';
import galleryReducer from './reducer/galleryReducer';
import onlineSession from './reducer/onlineSession';
import channelPartnerReducer from './reducer/channelPartnerReducer';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
}

const persistedReducer = persistReducer(persistConfig, categoryReducer)

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: persistedReducer,
    topic: topicReducer,
    modal: modalReducer,
    courseContent: courseContentReducer,
    users: userReducer,
    courses: coursesReducer,
    quiz: quizReducer,
    quizDetail: quizDetailsReducer,
    batchReducer: batchReducer,
    batchClassReducer: batchClassReducer,
    appContentReducer: appContentReducer,
    commonReducer: commonReducer,
    goalReducer: goalReducer,
    discountReducer: discountReducer,
    students: studentReducer,
    dashboard: dashboardReducer,
    orders: ordersReducer,
    roleReducer: roleReducer,
    testimonials: testimonialReducer,
    subjects: subjectsReducer,
    clearCache: clearCacheReducer,
    chats: chatReducer,
    companyDetail: companyDetailReducer,
    download: downloadReducer,
    auditUser,
    auditProcess: auditProcess,
    noticeBoard: noticeBoard,
    banner,
    notification: notification,
    handout,
    eSubjectsReducer: eSubjectsReducer,
    documentsReducer: documentsReducer,
    rulesReducer: rulesReducer,
    questionType: questionType,
    paperTypeReducer: paperTypeReducer,
    batchClassTypeReducer: batchClassTypeReducer,
    subjectPaperReducer: subjectPaperReducer,
    sectionNameReducer: sectionNameReducer,
    difficultyLevelReducer: difficultyLevelReducer,
    testPaperReducer: testPaperReducer,
    groupPaperReducer: groupPaperReducer,
    examPaperReducer: examPaperReducer,
    liveResultReducer: liveResultReducer,
    eSubjectGoalsReducer: eSubjectGoalsReducer,
    avatarReducer: avatarReducer,
    examCenterReducer: examCenterReducer,
    admitCardReducer: admitCardReducer,
    scholarshipReducer: scholarshipReducer,
    installmentReducer: installmentReducer,
    reportReducer: reportReducer,
    samplePaperReducer: samplePaperReducer,
    currentClassReducer: currentClassReducer,
    campusReducer: campusReducer,
    regUserReducer: regUserReducer,
    testEngagmentReducer: testEngagmentReducer,
    changeCourseReducer,
    resultListReducer,
    admissionReportReducer,
    noticePDFReducer,
    examCalendarReducer,
    feedbackReducer,
    academicYearReducer,
    userBatchReducer,
    facultyTaskReducer,
    sparkReducer,
    resultBanner,
    testSeriesReducer,
    jeeMarksReducer,
    enquiresReducer,
    messageReducer,
    agentEnquiresReducer,
    galleryReducer,
    onlineSession,
    channelPartnerReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store);